import { State, Store, Action, StateContext, Selector } from '@ngxs/store';
import { EngineProgressStateModel } from './engine.progress.state.model';
import { SetProgress } from './engine.progress.actions';
import { Injectable } from '@angular/core';


const initialState: EngineProgressStateModel = {
  storyLoadProgress: 0,
  chunkLoadProgress: 0
};

@State<EngineProgressStateModel>({
  name: 'engineProgress',
  defaults: initialState
})
@Injectable()
export class EngineProgressState {
  constructor(private store: Store) {}


  @Selector()
  static getStoryLoadProgress(state: EngineProgressStateModel) {
    return state.storyLoadProgress;
  }

  @Selector()
  static getChunkLoadProgress(state: EngineProgressStateModel) {
    return state.chunkLoadProgress;
  }

  @Action(SetProgress)
  setProgress(context: StateContext<EngineProgressStateModel>, action: SetProgress) {
    context.patchState({
      storyLoadProgress: action.storyLoadProgress,
      chunkLoadProgress: action.chunkLoadProgress
    });
  }
}
